var _path, _path2, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTariff(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16667 11.3333H9.16667C9.81183 11.3333 10.3333 10.8107 10.3333 10.1667V3.16667C10.3333 2.52267 9.81183 2 9.16667 2H2.16667C1.5215 2 1 2.52267 1 3.16667V10.1667C1 10.8107 1.5215 11.3333 2.16667 11.3333ZM3.33338 4.33338H8.00005V9.00005H3.33338V4.33338ZM20.8334 2H13.8334C13.1882 2 12.6667 2.52267 12.6667 3.16667V10.1667C12.6667 10.8107 13.1882 11.3333 13.8334 11.3333H20.8334C21.4785 11.3333 22 10.8107 22 10.1667V3.16667C22 2.52267 21.4785 2 20.8334 2ZM19.6667 9.00005H15.0001V4.33338H19.6667V9.00005ZM9.16667 23C9.81183 23 10.3333 22.4785 10.3333 21.8334V14.8334C10.3333 14.1882 9.81183 13.6667 9.16667 13.6667H2.16667C1.5215 13.6667 1 14.1882 1 14.8334V21.8334C1 22.4785 1.5215 23 2.16667 23H9.16667ZM3.33338 16.0001H8.00005V20.6667H3.33338V16.0001ZM18.5 14.8334H16.1667V17.1667H13.8334V19.5H16.1667V21.8334H18.5V19.5H20.8334V17.1667H18.5V14.8334Z",
    fill: "url(#paint0_linear_1867_3395)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16667 11.3333H9.16667C9.81183 11.3333 10.3333 10.8107 10.3333 10.1667V3.16667C10.3333 2.52267 9.81183 2 9.16667 2H2.16667C1.5215 2 1 2.52267 1 3.16667V10.1667C1 10.8107 1.5215 11.3333 2.16667 11.3333ZM3.33338 4.33338H8.00005V9.00005H3.33338V4.33338ZM20.8334 2H13.8334C13.1882 2 12.6667 2.52267 12.6667 3.16667V10.1667C12.6667 10.8107 13.1882 11.3333 13.8334 11.3333H20.8334C21.4785 11.3333 22 10.8107 22 10.1667V3.16667C22 2.52267 21.4785 2 20.8334 2ZM19.6667 9.00005H15.0001V4.33338H19.6667V9.00005ZM9.16667 23C9.81183 23 10.3333 22.4785 10.3333 21.8334V14.8334C10.3333 14.1882 9.81183 13.6667 9.16667 13.6667H2.16667C1.5215 13.6667 1 14.1882 1 14.8334V21.8334C1 22.4785 1.5215 23 2.16667 23H9.16667ZM3.33338 16.0001H8.00005V20.6667H3.33338V16.0001ZM18.5 14.8334H16.1667V17.1667H13.8334V19.5H16.1667V21.8334H18.5V19.5H20.8334V17.1667H18.5V14.8334Z",
    fill: "#6F00DE",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1867_3395",
    x1: 1,
    y1: 12.7561,
    x2: 22,
    y2: 12.7561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D273FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FF5D6"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTariff);
export default __webpack_public_path__ + "static/media/tariff.1f9ef0ef5e47a7622a8902e3076d254f.svg";
export { ForwardRef as ReactComponent };